import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            {/* footer: 인스타 주소 */}
            <h4>이화CCC가 더 궁금하다면?<br />
                Instargram <a href="https://www.instagram.com/ewhaccc/">@ewhaccc</a></h4>
        </footer>
    );
}

export default Footer;